module.exports = __webpack_public_path__ + "img/minus-circle.c3cce01b.svg";